exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-logo[data-v-65385283] {\n  height: 60px;\n}\n.nav-logo[data-v-65385283]:before, .nav-logo[data-v-65385283]:after {\n  content: \"\";\n  display: none;\n  position: absolute;\n  width: 30px;\n  height: 20px;\n  top: 0;\n  right: -30px;\n  z-index: 2;\n}\n.nav-logo[data-v-65385283]:before {\n  background-color: #eef5ff;\n  border-radius: 0 0 30px 0;\n  width: 6px;\n  height: 6px;\n  overflow: hidden;\n  right: -6px;\n}\n.nav-logo[data-v-65385283]:after {\n  background-color: #eef5ff;\n  border-radius: 30px 0 0 30px;\n}\n.logo[data-v-65385283] {\n  width: 85px;\n  height: 28px;\n}", ""]);

// exports
